import debounce from "lodash.debounce";

// Debounced storage wrapper to reduce localStorage write frequency
// This prevents UI jank during rapid state updates (e.g., dragging, typing)
export const createDebouncedStorage = (storage, delay = 500) => ({
  getItem: (name) => storage.getItem(name),
  setItem: debounce((name, value) => {
    storage.setItem(name, value);
  }, delay),
  removeItem: (name) => storage.removeItem(name),
});
